import SectionsList from './SectionsList';

export default SectionsList;
